import MostWithHafa from './MostWithHafa.vue'
import LeastWithHafa from './LeastWithHafa.vue'
import MostLeastTabs from './MostLeastTabs.vue'

const mostLeastComponents = [MostWithHafa, MostLeastTabs, LeastWithHafa]

export default mostLeastComponents
